import styled from 'styled-components/native';

export const Header = styled.View`
  padding-horizontal: 16px;
`;

export const List = styled.FlatList``;
